import { Navigate } from 'react-router'

import { useDashboardContext } from './context/DashboardContext'

export const DashboardIndexRedirect = () => {
  const { callCenterEnabled } = useDashboardContext()
  const defaultPath = callCenterEnabled
    ? 'queue-dashboard'
    : 'inbound-answer-rate'
  return <Navigate to={defaultPath} replace />
}
